import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import useEntityTypes, { PERSON_ENTITY_TYPE_KEY } from 'helpers/useEntityTypes';
import { combineStatuses, useStatus } from 'resift';
import _get from 'lodash/get';
import showSnackbar from 'helpers/showSnackbar';
import { HOME_URL, DYNAMIC_PAGES_URL, PERSON_PROFILE_URL } from 'components/Router/consts';

// Component
import DeleteAttribute from './DeleteAttribute';

// Actions
import makeDeleteCategoryFieldFetch from 'store/attribute/actions/deleteCategoryFieldFetch';
import makeUpdateCategoryFieldFetch from 'store/attribute/actions/updateCategoryFieldFetch';
import makeEntityTypesFetch from 'store/configuration/actions/entityTypesFetch';

function Container(props) {
  const dispatch = useDispatch();
  const entityTypes = useEntityTypes();
  const history = useHistory();
  const { entityTypeKey } = useParams();
  const entityType = _get(entityTypes, entityTypeKey);
  const fieldId = _get(props, 'field.id', null);
  const deleteFieldFetch = fieldId ? makeDeleteCategoryFieldFetch(fieldId) : null;
  const deleteFieldStatus = deleteFieldFetch ? useStatus(deleteFieldFetch) : 1;
  const entityTypesFetch = makeEntityTypesFetch();
  const entityTypesStatus = useStatus(entityTypesFetch);
  const updateField = makeUpdateCategoryFieldFetch();
  const updateFieldStatus = useStatus(updateField);

  showSnackbar({
    status: deleteFieldStatus,
    message: 'Successfully deleted attribute.',
    errorMessage: 'An error occurred while deleting the attribute.',
  });

  const handleRedirect = async () => {
    await dispatch(entityTypesFetch());
    history.push(
      entityTypeKey === PERSON_ENTITY_TYPE_KEY
        ? `/admin${PERSON_PROFILE_URL}`
        : `${HOME_URL}${DYNAMIC_PAGES_URL}/${entityTypeKey}/attribute`,
    );
  };

  const handleDelete = useCallback(
    async field => {
      await dispatch(deleteFieldFetch(field.id));
      if (field.objectKey.includes('.')) {
        const parentKey = field.objectKey.split('.')[0];
        const parentField = parentKey ? _get(entityType, `_fields['${parentKey}']`, null) : null;
        if (parentField) {
          const parentPayload = {
            ...parentField,
            fields: [...parentField.fields.filter(parentField => parentField !== field.objectKey)],
          };
          await dispatch(updateField(parentField.id, parentPayload));
          dispatch(entityTypesFetch());
        } else {
          handleRedirect();
        }
      } else {
        handleRedirect();
      }
    },
    [entityType],
  );

  const combinedLoadingStatus = combineStatuses(
    deleteFieldStatus | 1,
    updateFieldStatus | 1,
    entityTypesStatus | 1,
  );

  return (
    <DeleteAttribute deleteCategoryField={handleDelete} status={combinedLoadingStatus} {...props} />
  );
}

export default memo(Container);
